/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as WaitListImport } from './routes/wait-list'
import { Route as UnsubscribedImport } from './routes/unsubscribed'
import { Route as StoriesImport } from './routes/stories'
import { Route as SignUpImport } from './routes/sign-up'
import { Route as SettingsImport } from './routes/settings'
import { Route as OnboardingImport } from './routes/onboarding'
import { Route as LogoutImport } from './routes/logout'
import { Route as LoginImport } from './routes/login'
import { Route as LogInImport } from './routes/log-in'
import { Route as ForgotPasswordImport } from './routes/forgot-password'
import { Route as AppImport } from './routes/app'
import { Route as IndexImport } from './routes/index'
import { Route as AppIndexImport } from './routes/app/index'
import { Route as TasksNewImport } from './routes/tasks/new'
import { Route as TasksTaskIdImport } from './routes/tasks/$taskId'
import { Route as ResetPasswordTokenImport } from './routes/reset-password/$token'
import { Route as AppThreadImport } from './routes/app/thread'
import { Route as AppSettingsImport } from './routes/app/settings'
import { Route as AppHomeImport } from './routes/app/home'
import { Route as AcceptInviteInviteIdImport } from './routes/accept-invite/$inviteId'
import { Route as OptionsOptionSheetIdIndexImport } from './routes/options/$optionSheetId/index'
import { Route as AppTaskIndexImport } from './routes/app/task/index'
import { Route as AppSettingsIndexImport } from './routes/app/settings/index'
import { Route as AppRecurrenceIndexImport } from './routes/app/recurrence/index'
import { Route as AppLetterRecommendationIndexImport } from './routes/app/letter-recommendation/index'
import { Route as AppCalendarRecurrenceIndexImport } from './routes/app/calendar-recurrence/index'
import { Route as AppThreadCreateImport } from './routes/app/thread/create'
import { Route as AppThreadThreadIdImport } from './routes/app/thread/$threadId'
import { Route as AppTaskCreateImport } from './routes/app/task/create'
import { Route as AppTaskTaskIdImport } from './routes/app/task/$taskId'
import { Route as AppSettingsPaymentsImport } from './routes/app/settings/payments'
import { Route as AppSettingsNotificationsImport } from './routes/app/settings/notifications'
import { Route as AppSettingsInviteFriendsImport } from './routes/app/settings/invite-friends'
import { Route as AppSettingsFeedbackImport } from './routes/app/settings/feedback'
import { Route as AppSettingsEmailPasswordImport } from './routes/app/settings/email-password'
import { Route as AppSettingsDownloadAppImport } from './routes/app/settings/download-app'
import { Route as AppSettingsCalendarImport } from './routes/app/settings/calendar'
import { Route as AppRecurrenceCreateImport } from './routes/app/recurrence/create'
import { Route as AppRecurrenceRecurrenceIdImport } from './routes/app/recurrence/$recurrenceId'
import { Route as AppLetterRecommendationLetterRecommendationIdImport } from './routes/app/letter-recommendation/$letterRecommendationId'
import { Route as AppDraftTaskDraftTaskIdImport } from './routes/app/draft-task/$draftTaskId'
import { Route as AppOptionSheetOptionSheetIdIndexImport } from './routes/app/option-sheet/$optionSheetId/index'

// Create/Update Routes

const WaitListRoute = WaitListImport.update({
  path: '/wait-list',
  getParentRoute: () => rootRoute,
} as any)

const UnsubscribedRoute = UnsubscribedImport.update({
  path: '/unsubscribed',
  getParentRoute: () => rootRoute,
} as any)

const StoriesRoute = StoriesImport.update({
  path: '/stories',
  getParentRoute: () => rootRoute,
} as any)

const SignUpRoute = SignUpImport.update({
  path: '/sign-up',
  getParentRoute: () => rootRoute,
} as any)

const SettingsRoute = SettingsImport.update({
  path: '/settings',
  getParentRoute: () => rootRoute,
} as any)

const OnboardingRoute = OnboardingImport.update({
  path: '/onboarding',
  getParentRoute: () => rootRoute,
} as any)

const LogoutRoute = LogoutImport.update({
  path: '/logout',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const LogInRoute = LogInImport.update({
  path: '/log-in',
  getParentRoute: () => rootRoute,
} as any)

const ForgotPasswordRoute = ForgotPasswordImport.update({
  path: '/forgot-password',
  getParentRoute: () => rootRoute,
} as any)

const AppRoute = AppImport.update({
  path: '/app',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AppIndexRoute = AppIndexImport.update({
  path: '/',
  getParentRoute: () => AppRoute,
} as any)

const TasksNewRoute = TasksNewImport.update({
  path: '/tasks/new',
  getParentRoute: () => rootRoute,
} as any)

const TasksTaskIdRoute = TasksTaskIdImport.update({
  path: '/tasks/$taskId',
  getParentRoute: () => rootRoute,
} as any)

const ResetPasswordTokenRoute = ResetPasswordTokenImport.update({
  path: '/reset-password/$token',
  getParentRoute: () => rootRoute,
} as any)

const AppThreadRoute = AppThreadImport.update({
  path: '/thread',
  getParentRoute: () => AppRoute,
} as any)

const AppSettingsRoute = AppSettingsImport.update({
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)

const AppHomeRoute = AppHomeImport.update({
  path: '/home',
  getParentRoute: () => AppRoute,
} as any)

const AcceptInviteInviteIdRoute = AcceptInviteInviteIdImport.update({
  path: '/accept-invite/$inviteId',
  getParentRoute: () => rootRoute,
} as any)

const OptionsOptionSheetIdIndexRoute = OptionsOptionSheetIdIndexImport.update({
  path: '/options/$optionSheetId/',
  getParentRoute: () => rootRoute,
} as any)

const AppTaskIndexRoute = AppTaskIndexImport.update({
  path: '/task/',
  getParentRoute: () => AppRoute,
} as any)

const AppSettingsIndexRoute = AppSettingsIndexImport.update({
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)

const AppRecurrenceIndexRoute = AppRecurrenceIndexImport.update({
  path: '/recurrence/',
  getParentRoute: () => AppRoute,
} as any)

const AppLetterRecommendationIndexRoute =
  AppLetterRecommendationIndexImport.update({
    path: '/letter-recommendation/',
    getParentRoute: () => AppRoute,
  } as any)

const AppCalendarRecurrenceIndexRoute = AppCalendarRecurrenceIndexImport.update(
  {
    path: '/calendar-recurrence/',
    getParentRoute: () => AppRoute,
  } as any,
)

const AppThreadCreateRoute = AppThreadCreateImport.update({
  path: '/create',
  getParentRoute: () => AppThreadRoute,
} as any)

const AppThreadThreadIdRoute = AppThreadThreadIdImport.update({
  path: '/$threadId',
  getParentRoute: () => AppThreadRoute,
} as any)

const AppTaskCreateRoute = AppTaskCreateImport.update({
  path: '/task/create',
  getParentRoute: () => AppRoute,
} as any)

const AppTaskTaskIdRoute = AppTaskTaskIdImport.update({
  path: '/task/$taskId',
  getParentRoute: () => AppRoute,
} as any)

const AppSettingsPaymentsRoute = AppSettingsPaymentsImport.update({
  path: '/payments',
  getParentRoute: () => AppSettingsRoute,
} as any)

const AppSettingsNotificationsRoute = AppSettingsNotificationsImport.update({
  path: '/notifications',
  getParentRoute: () => AppSettingsRoute,
} as any)

const AppSettingsInviteFriendsRoute = AppSettingsInviteFriendsImport.update({
  path: '/invite-friends',
  getParentRoute: () => AppSettingsRoute,
} as any)

const AppSettingsFeedbackRoute = AppSettingsFeedbackImport.update({
  path: '/feedback',
  getParentRoute: () => AppSettingsRoute,
} as any)

const AppSettingsEmailPasswordRoute = AppSettingsEmailPasswordImport.update({
  path: '/email-password',
  getParentRoute: () => AppSettingsRoute,
} as any)

const AppSettingsDownloadAppRoute = AppSettingsDownloadAppImport.update({
  path: '/download-app',
  getParentRoute: () => AppSettingsRoute,
} as any)

const AppSettingsCalendarRoute = AppSettingsCalendarImport.update({
  path: '/calendar',
  getParentRoute: () => AppSettingsRoute,
} as any)

const AppRecurrenceCreateRoute = AppRecurrenceCreateImport.update({
  path: '/recurrence/create',
  getParentRoute: () => AppRoute,
} as any)

const AppRecurrenceRecurrenceIdRoute = AppRecurrenceRecurrenceIdImport.update({
  path: '/recurrence/$recurrenceId',
  getParentRoute: () => AppRoute,
} as any)

const AppLetterRecommendationLetterRecommendationIdRoute =
  AppLetterRecommendationLetterRecommendationIdImport.update({
    path: '/letter-recommendation/$letterRecommendationId',
    getParentRoute: () => AppRoute,
  } as any)

const AppDraftTaskDraftTaskIdRoute = AppDraftTaskDraftTaskIdImport.update({
  path: '/draft-task/$draftTaskId',
  getParentRoute: () => AppRoute,
} as any)

const AppOptionSheetOptionSheetIdIndexRoute =
  AppOptionSheetOptionSheetIdIndexImport.update({
    path: '/option-sheet/$optionSheetId/',
    getParentRoute: () => AppRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppImport
      parentRoute: typeof rootRoute
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordImport
      parentRoute: typeof rootRoute
    }
    '/log-in': {
      id: '/log-in'
      path: '/log-in'
      fullPath: '/log-in'
      preLoaderRoute: typeof LogInImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutImport
      parentRoute: typeof rootRoute
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingImport
      parentRoute: typeof rootRoute
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsImport
      parentRoute: typeof rootRoute
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpImport
      parentRoute: typeof rootRoute
    }
    '/stories': {
      id: '/stories'
      path: '/stories'
      fullPath: '/stories'
      preLoaderRoute: typeof StoriesImport
      parentRoute: typeof rootRoute
    }
    '/unsubscribed': {
      id: '/unsubscribed'
      path: '/unsubscribed'
      fullPath: '/unsubscribed'
      preLoaderRoute: typeof UnsubscribedImport
      parentRoute: typeof rootRoute
    }
    '/wait-list': {
      id: '/wait-list'
      path: '/wait-list'
      fullPath: '/wait-list'
      preLoaderRoute: typeof WaitListImport
      parentRoute: typeof rootRoute
    }
    '/accept-invite/$inviteId': {
      id: '/accept-invite/$inviteId'
      path: '/accept-invite/$inviteId'
      fullPath: '/accept-invite/$inviteId'
      preLoaderRoute: typeof AcceptInviteInviteIdImport
      parentRoute: typeof rootRoute
    }
    '/app/home': {
      id: '/app/home'
      path: '/home'
      fullPath: '/app/home'
      preLoaderRoute: typeof AppHomeImport
      parentRoute: typeof AppImport
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsImport
      parentRoute: typeof AppImport
    }
    '/app/thread': {
      id: '/app/thread'
      path: '/thread'
      fullPath: '/app/thread'
      preLoaderRoute: typeof AppThreadImport
      parentRoute: typeof AppImport
    }
    '/reset-password/$token': {
      id: '/reset-password/$token'
      path: '/reset-password/$token'
      fullPath: '/reset-password/$token'
      preLoaderRoute: typeof ResetPasswordTokenImport
      parentRoute: typeof rootRoute
    }
    '/tasks/$taskId': {
      id: '/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/tasks/$taskId'
      preLoaderRoute: typeof TasksTaskIdImport
      parentRoute: typeof rootRoute
    }
    '/tasks/new': {
      id: '/tasks/new'
      path: '/tasks/new'
      fullPath: '/tasks/new'
      preLoaderRoute: typeof TasksNewImport
      parentRoute: typeof rootRoute
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexImport
      parentRoute: typeof AppImport
    }
    '/app/draft-task/$draftTaskId': {
      id: '/app/draft-task/$draftTaskId'
      path: '/draft-task/$draftTaskId'
      fullPath: '/app/draft-task/$draftTaskId'
      preLoaderRoute: typeof AppDraftTaskDraftTaskIdImport
      parentRoute: typeof AppImport
    }
    '/app/letter-recommendation/$letterRecommendationId': {
      id: '/app/letter-recommendation/$letterRecommendationId'
      path: '/letter-recommendation/$letterRecommendationId'
      fullPath: '/app/letter-recommendation/$letterRecommendationId'
      preLoaderRoute: typeof AppLetterRecommendationLetterRecommendationIdImport
      parentRoute: typeof AppImport
    }
    '/app/recurrence/$recurrenceId': {
      id: '/app/recurrence/$recurrenceId'
      path: '/recurrence/$recurrenceId'
      fullPath: '/app/recurrence/$recurrenceId'
      preLoaderRoute: typeof AppRecurrenceRecurrenceIdImport
      parentRoute: typeof AppImport
    }
    '/app/recurrence/create': {
      id: '/app/recurrence/create'
      path: '/recurrence/create'
      fullPath: '/app/recurrence/create'
      preLoaderRoute: typeof AppRecurrenceCreateImport
      parentRoute: typeof AppImport
    }
    '/app/settings/calendar': {
      id: '/app/settings/calendar'
      path: '/calendar'
      fullPath: '/app/settings/calendar'
      preLoaderRoute: typeof AppSettingsCalendarImport
      parentRoute: typeof AppSettingsImport
    }
    '/app/settings/download-app': {
      id: '/app/settings/download-app'
      path: '/download-app'
      fullPath: '/app/settings/download-app'
      preLoaderRoute: typeof AppSettingsDownloadAppImport
      parentRoute: typeof AppSettingsImport
    }
    '/app/settings/email-password': {
      id: '/app/settings/email-password'
      path: '/email-password'
      fullPath: '/app/settings/email-password'
      preLoaderRoute: typeof AppSettingsEmailPasswordImport
      parentRoute: typeof AppSettingsImport
    }
    '/app/settings/feedback': {
      id: '/app/settings/feedback'
      path: '/feedback'
      fullPath: '/app/settings/feedback'
      preLoaderRoute: typeof AppSettingsFeedbackImport
      parentRoute: typeof AppSettingsImport
    }
    '/app/settings/invite-friends': {
      id: '/app/settings/invite-friends'
      path: '/invite-friends'
      fullPath: '/app/settings/invite-friends'
      preLoaderRoute: typeof AppSettingsInviteFriendsImport
      parentRoute: typeof AppSettingsImport
    }
    '/app/settings/notifications': {
      id: '/app/settings/notifications'
      path: '/notifications'
      fullPath: '/app/settings/notifications'
      preLoaderRoute: typeof AppSettingsNotificationsImport
      parentRoute: typeof AppSettingsImport
    }
    '/app/settings/payments': {
      id: '/app/settings/payments'
      path: '/payments'
      fullPath: '/app/settings/payments'
      preLoaderRoute: typeof AppSettingsPaymentsImport
      parentRoute: typeof AppSettingsImport
    }
    '/app/task/$taskId': {
      id: '/app/task/$taskId'
      path: '/task/$taskId'
      fullPath: '/app/task/$taskId'
      preLoaderRoute: typeof AppTaskTaskIdImport
      parentRoute: typeof AppImport
    }
    '/app/task/create': {
      id: '/app/task/create'
      path: '/task/create'
      fullPath: '/app/task/create'
      preLoaderRoute: typeof AppTaskCreateImport
      parentRoute: typeof AppImport
    }
    '/app/thread/$threadId': {
      id: '/app/thread/$threadId'
      path: '/$threadId'
      fullPath: '/app/thread/$threadId'
      preLoaderRoute: typeof AppThreadThreadIdImport
      parentRoute: typeof AppThreadImport
    }
    '/app/thread/create': {
      id: '/app/thread/create'
      path: '/create'
      fullPath: '/app/thread/create'
      preLoaderRoute: typeof AppThreadCreateImport
      parentRoute: typeof AppThreadImport
    }
    '/app/calendar-recurrence/': {
      id: '/app/calendar-recurrence/'
      path: '/calendar-recurrence'
      fullPath: '/app/calendar-recurrence'
      preLoaderRoute: typeof AppCalendarRecurrenceIndexImport
      parentRoute: typeof AppImport
    }
    '/app/letter-recommendation/': {
      id: '/app/letter-recommendation/'
      path: '/letter-recommendation'
      fullPath: '/app/letter-recommendation'
      preLoaderRoute: typeof AppLetterRecommendationIndexImport
      parentRoute: typeof AppImport
    }
    '/app/recurrence/': {
      id: '/app/recurrence/'
      path: '/recurrence'
      fullPath: '/app/recurrence'
      preLoaderRoute: typeof AppRecurrenceIndexImport
      parentRoute: typeof AppImport
    }
    '/app/settings/': {
      id: '/app/settings/'
      path: '/'
      fullPath: '/app/settings/'
      preLoaderRoute: typeof AppSettingsIndexImport
      parentRoute: typeof AppSettingsImport
    }
    '/app/task/': {
      id: '/app/task/'
      path: '/task'
      fullPath: '/app/task'
      preLoaderRoute: typeof AppTaskIndexImport
      parentRoute: typeof AppImport
    }
    '/options/$optionSheetId/': {
      id: '/options/$optionSheetId/'
      path: '/options/$optionSheetId'
      fullPath: '/options/$optionSheetId'
      preLoaderRoute: typeof OptionsOptionSheetIdIndexImport
      parentRoute: typeof rootRoute
    }
    '/app/option-sheet/$optionSheetId/': {
      id: '/app/option-sheet/$optionSheetId/'
      path: '/option-sheet/$optionSheetId'
      fullPath: '/app/option-sheet/$optionSheetId'
      preLoaderRoute: typeof AppOptionSheetOptionSheetIdIndexImport
      parentRoute: typeof AppImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexRoute,
  AppRoute: AppRoute.addChildren({
    AppHomeRoute,
    AppSettingsRoute: AppSettingsRoute.addChildren({
      AppSettingsCalendarRoute,
      AppSettingsDownloadAppRoute,
      AppSettingsEmailPasswordRoute,
      AppSettingsFeedbackRoute,
      AppSettingsInviteFriendsRoute,
      AppSettingsNotificationsRoute,
      AppSettingsPaymentsRoute,
      AppSettingsIndexRoute,
    }),
    AppThreadRoute: AppThreadRoute.addChildren({
      AppThreadThreadIdRoute,
      AppThreadCreateRoute,
    }),
    AppIndexRoute,
    AppDraftTaskDraftTaskIdRoute,
    AppLetterRecommendationLetterRecommendationIdRoute,
    AppRecurrenceRecurrenceIdRoute,
    AppRecurrenceCreateRoute,
    AppTaskTaskIdRoute,
    AppTaskCreateRoute,
    AppCalendarRecurrenceIndexRoute,
    AppLetterRecommendationIndexRoute,
    AppRecurrenceIndexRoute,
    AppTaskIndexRoute,
    AppOptionSheetOptionSheetIdIndexRoute,
  }),
  ForgotPasswordRoute,
  LogInRoute,
  LoginRoute,
  LogoutRoute,
  OnboardingRoute,
  SettingsRoute,
  SignUpRoute,
  StoriesRoute,
  UnsubscribedRoute,
  WaitListRoute,
  AcceptInviteInviteIdRoute,
  ResetPasswordTokenRoute,
  TasksTaskIdRoute,
  TasksNewRoute,
  OptionsOptionSheetIdIndexRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/app",
        "/forgot-password",
        "/log-in",
        "/login",
        "/logout",
        "/onboarding",
        "/settings",
        "/sign-up",
        "/stories",
        "/unsubscribed",
        "/wait-list",
        "/accept-invite/$inviteId",
        "/reset-password/$token",
        "/tasks/$taskId",
        "/tasks/new",
        "/options/$optionSheetId/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/app": {
      "filePath": "app.tsx",
      "children": [
        "/app/home",
        "/app/settings",
        "/app/thread",
        "/app/",
        "/app/draft-task/$draftTaskId",
        "/app/letter-recommendation/$letterRecommendationId",
        "/app/recurrence/$recurrenceId",
        "/app/recurrence/create",
        "/app/task/$taskId",
        "/app/task/create",
        "/app/calendar-recurrence/",
        "/app/letter-recommendation/",
        "/app/recurrence/",
        "/app/task/",
        "/app/option-sheet/$optionSheetId/"
      ]
    },
    "/forgot-password": {
      "filePath": "forgot-password.tsx"
    },
    "/log-in": {
      "filePath": "log-in.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/logout": {
      "filePath": "logout.tsx"
    },
    "/onboarding": {
      "filePath": "onboarding.tsx"
    },
    "/settings": {
      "filePath": "settings.tsx"
    },
    "/sign-up": {
      "filePath": "sign-up.tsx"
    },
    "/stories": {
      "filePath": "stories.tsx"
    },
    "/unsubscribed": {
      "filePath": "unsubscribed.tsx"
    },
    "/wait-list": {
      "filePath": "wait-list.tsx"
    },
    "/accept-invite/$inviteId": {
      "filePath": "accept-invite/$inviteId.tsx"
    },
    "/app/home": {
      "filePath": "app/home.tsx",
      "parent": "/app"
    },
    "/app/settings": {
      "filePath": "app/settings.tsx",
      "parent": "/app",
      "children": [
        "/app/settings/calendar",
        "/app/settings/download-app",
        "/app/settings/email-password",
        "/app/settings/feedback",
        "/app/settings/invite-friends",
        "/app/settings/notifications",
        "/app/settings/payments",
        "/app/settings/"
      ]
    },
    "/app/thread": {
      "filePath": "app/thread.tsx",
      "parent": "/app",
      "children": [
        "/app/thread/$threadId",
        "/app/thread/create"
      ]
    },
    "/reset-password/$token": {
      "filePath": "reset-password/$token.tsx"
    },
    "/tasks/$taskId": {
      "filePath": "tasks/$taskId.tsx"
    },
    "/tasks/new": {
      "filePath": "tasks/new.tsx"
    },
    "/app/": {
      "filePath": "app/index.tsx",
      "parent": "/app"
    },
    "/app/draft-task/$draftTaskId": {
      "filePath": "app/draft-task/$draftTaskId.tsx",
      "parent": "/app"
    },
    "/app/letter-recommendation/$letterRecommendationId": {
      "filePath": "app/letter-recommendation/$letterRecommendationId.tsx",
      "parent": "/app"
    },
    "/app/recurrence/$recurrenceId": {
      "filePath": "app/recurrence/$recurrenceId.tsx",
      "parent": "/app"
    },
    "/app/recurrence/create": {
      "filePath": "app/recurrence/create.tsx",
      "parent": "/app"
    },
    "/app/settings/calendar": {
      "filePath": "app/settings/calendar.tsx",
      "parent": "/app/settings"
    },
    "/app/settings/download-app": {
      "filePath": "app/settings/download-app.tsx",
      "parent": "/app/settings"
    },
    "/app/settings/email-password": {
      "filePath": "app/settings/email-password.tsx",
      "parent": "/app/settings"
    },
    "/app/settings/feedback": {
      "filePath": "app/settings/feedback.tsx",
      "parent": "/app/settings"
    },
    "/app/settings/invite-friends": {
      "filePath": "app/settings/invite-friends.tsx",
      "parent": "/app/settings"
    },
    "/app/settings/notifications": {
      "filePath": "app/settings/notifications.tsx",
      "parent": "/app/settings"
    },
    "/app/settings/payments": {
      "filePath": "app/settings/payments.tsx",
      "parent": "/app/settings"
    },
    "/app/task/$taskId": {
      "filePath": "app/task/$taskId.tsx",
      "parent": "/app"
    },
    "/app/task/create": {
      "filePath": "app/task/create.tsx",
      "parent": "/app"
    },
    "/app/thread/$threadId": {
      "filePath": "app/thread/$threadId.tsx",
      "parent": "/app/thread"
    },
    "/app/thread/create": {
      "filePath": "app/thread/create.tsx",
      "parent": "/app/thread"
    },
    "/app/calendar-recurrence/": {
      "filePath": "app/calendar-recurrence/index.tsx",
      "parent": "/app"
    },
    "/app/letter-recommendation/": {
      "filePath": "app/letter-recommendation/index.tsx",
      "parent": "/app"
    },
    "/app/recurrence/": {
      "filePath": "app/recurrence/index.tsx",
      "parent": "/app"
    },
    "/app/settings/": {
      "filePath": "app/settings/index.tsx",
      "parent": "/app/settings"
    },
    "/app/task/": {
      "filePath": "app/task/index.tsx",
      "parent": "/app"
    },
    "/options/$optionSheetId/": {
      "filePath": "options/$optionSheetId/index.tsx"
    },
    "/app/option-sheet/$optionSheetId/": {
      "filePath": "app/option-sheet/$optionSheetId/index.tsx",
      "parent": "/app"
    }
  }
}
ROUTE_MANIFEST_END */
